// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3c3Jg","name":"ConsentHeader_name__25Oey","birthday":"ConsentHeader_birthday__TTMgq","skeleton":"ConsentHeader_skeleton__1fhTK"};